// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoButton_wrapper__3xlph","button":"InfoButton_button__moqZ9","i":"InfoButton_i__zwXEm","infoBox":"InfoButton_infoBox__nIdcw"};